import './index.scss';
import React, { useEffect, useMemo, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Tab, Tabs } from '~/components_to_be_packaged/tabs/tabs';
import { useAppSidebar } from '~/layout/main_layout/app_sidebar/provider';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useWorkspaceFolder } from '../provider';
import ComparisonsTab from './comparisons_tab';
import { ComparisonGridProvider, } from './comparisons_tab/comparison_grid/provider';
import DocumentTab from './document_tab';
export const ProjectWorkspaceTabs = {
    DOCUMENTS: 'documents',
    DOCUMENT_COMPARISON: 'document-comparison',
};
const CenterPanel = () => {
    const { activeFolderId } = useWorkspaceFolder();
    const { activeTab } = useParams();
    const { projectsWorkspaces } = useAppSidebar();
    const currentActiveTab = useRef(0);
    const navigate = useNavigate();
    const { hasPermission } = useUser();
    const [defaultTab, visibleTabNames] = useMemo(() => {
        const visibleTabs = [];
        if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENT_COMPARISONS)) {
            visibleTabs.push(ProjectWorkspaceTabs.DOCUMENT_COMPARISON);
        }
        if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS)) {
            visibleTabs.push(ProjectWorkspaceTabs.DOCUMENTS);
        }
        if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENT_COMPARISONS)) {
            return [ProjectWorkspaceTabs.DOCUMENT_COMPARISON, visibleTabs];
        }
        else if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS)) {
            return [ProjectWorkspaceTabs.DOCUMENTS, visibleTabs];
        }
        return ['', visibleTabs];
    }, [hasPermission]);
    useEffect(() => {
        if (!activeTab ||
            (activeTab === ProjectWorkspaceTabs.DOCUMENT_COMPARISON &&
                !hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENT_COMPARISONS)) ||
            (activeTab === ProjectWorkspaceTabs.DOCUMENTS &&
                !hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS))) {
            navigate(`/projects-workspace/${defaultTab}/${activeFolderId !== null && activeFolderId !== void 0 ? activeFolderId : ''}`);
        }
    }, [activeFolderId, hasPermission]);
    const index = visibleTabNames.findIndex(t => t === (activeTab !== null && activeTab !== void 0 ? activeTab : defaultTab));
    const activeTabIndex = index > -1 ? index : 0;
    const searchTreeNode = (nodeId, nodes) => {
        for (const node of nodes) {
            if (node.id === nodeId) {
                return node;
            }
            else if (node.children && node.children.length > 0) {
                const found = searchTreeNode(nodeId, node.children);
                if (found) {
                    return found;
                }
            }
        }
    };
    let projectWorkspace;
    if (projectsWorkspaces && activeFolderId) {
        projectWorkspace = searchTreeNode(activeFolderId, projectsWorkspaces);
    }
    const handleTabChange = (activeTabIndex) => {
        currentActiveTab.current = activeTabIndex;
        navigate(`/projects-workspace/${visibleTabNames[activeTabIndex]}/${activeFolderId !== null && activeFolderId !== void 0 ? activeFolderId : ''}`, { replace: true });
    };
    const tabs = [];
    if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENT_COMPARISONS)) {
        tabs.push(React.createElement(Tab, { title: "Comparisons", icon: 'fa-regular fa-copy' },
            React.createElement(ComparisonGridProvider, null,
                React.createElement(ComparisonsTab, null))));
    }
    if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENTS)) {
        tabs.push(React.createElement(Tab, { title: "Saved Documents", icon: 'fa-regular fa-file' },
            React.createElement("div", { className: 'saved-document-container' },
                React.createElement(DocumentTab, null))));
    }
    if (hasPermission(Permissions.VIEW_SAVED_SEARCH_PAGE)) {
        tabs.push(React.createElement(Tab, { title: "Saved Searches", icon: 'fa-regular fa-floppy-disk' },
            React.createElement("div", { className: 'saved-search-container' }, "Replace the component Here")));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "workspace-center-panel-container" },
            React.createElement("div", { className: "folder-title" }, !(projectWorkspace === null || projectWorkspace === void 0 ? void 0 : projectWorkspace.name) || !activeFolderId
                ? 'No folder selected'
                : projectWorkspace === null || projectWorkspace === void 0 ? void 0 : projectWorkspace.name),
            React.createElement("div", { className: "workspace-center-panel" },
                React.createElement(Tabs, { defaultTab: activeTabIndex, onTabChange: handleTabChange }, tabs)))));
};
export default CenterPanel;
